import { Store } from '@tencent/workbench-core';
import { Provider } from '@tencent/ioc';

// 禁用此规则是因为下划线仍然是非常合适的用于描述私有变量的前缀
// 尤其是当我们需要用无下划线的版本来做 getter/setter 时
/**
 * @internal
 */
class ProviderStorable extends Provider {
    constructor(provide) {
        super(provide);
        this._store = Store.from(provide);
    }
    get useClass() {
        return this._useClass || this.provide;
    }
    set useClass(value) {
        this._store = Store.from(value);
        this._useClass = value;
    }
    get store() {
        return this._store;
    }
    get scope() {
        return this.store.get('st ore');
    }
    set scope(scope) {
        this.store.set('store', scope);
    }
}

export { ProviderStorable };
//# sourceMappingURL=provider-storable.js.map
